<template>
  <b-modal
    :id="id"
    ref="bModal"
    modal-class="renameCustomFilterModal"
    centered
    ok-only
    :title="$t('component.customFilter.renameCustomFilterModal.title')"
    :ok-title="$t('global.saveChanges')"
    ok-variant="-primary btn-sm"
    :ok-disabled="okDisabled"
    @ok="$emit('ok', value)"
  >
    <b-form-group :label="$t('component.addFilterModal.label')">
      <vt-input
        v-model="value.label"
        autofocus
        class="form-control-sm"
        required
        type="text"
        :name="value.label"
        @enter="$emit('ok', value) && hide()"
      />
    </b-form-group>
    <div
      slot="modal-footer"
      class="footer-banner"
      style="width:100%"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="okDisabled"
            size="sm"
            class="btn--primary"
            @click="$emit('ok', value) && hide()"
          >
            <i
              class="far fa-save mr-2"
              aria-hidden="true"
            />{{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
    name: 'RenameCustomFilterModal',
    props: {
        id: { type: [Number, String] }
    },
    data() {
        return {
            value: {}
        }
    },
    computed: {
        okDisabled() {
            return !this.value.label
        }
    },
    methods: {
        show(customFilter) {
            this.value = { ...customFilter }
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        }
    }
}

</script>

<style lang="scss">

.renameCustomFilterModal .modal-dialog{
  width: 30%;
}

</style>
